var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"justify-start pt-6",staticStyle:{"color":"#333","white-space":"break-spaces"}},[_vm._v(" "+_vm._s(_vm.$t('onboarding_complete_hint'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('img',{staticClass:"px-4 w-1/2",attrs:{"src":require("../../../assets/logo.svg"),"alt":"IMD-CONNECT.PRO"}})])
}]

export { render, staticRenderFns }